import React from "react";
// import PropTypes from 'prop-types';
import Wrapper from "./styles/no-engagements-styles";

const Awaiting = () => (
  <Wrapper>You currently have no new engagements to review</Wrapper>
);

export default Awaiting;
